module.exports = __webpack_public_path__ + "static/media/unicc.a499e9fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/unicc.jpg
// module id = 1131
// module chunks = 4